module.exports = __webpack_public_path__ + "img/Connection-Lost.785f21d4.svg";